import React from 'react';

export const BaseContext = React.createContext();
